import classNames from "classnames";
import { useStorageSelectors } from "../../../../app/state/storageObjectSlice/hook/use-storage-selectors";
import { FrameComponent } from "../../../../common/FrameComponent";
import { useAppSelector } from "../../../../services/redux/hooks/use-selector";
import { DRAWIO_VIEWER_URI } from "../../../Schemas/constants";
import { useFilePreviewer } from "../../hooks/use-file-previewer";
import {
  selectFileConfig,
  selectFilesValue,
  selectIsFileLoading,
} from "../../redux/selectors";
import { FilesHeader } from "./FilesHeader";
import { SkeletonPreview } from "./SkeletonPreview";
import styles from "./styles.module.css";
import { AppMarkdownParser } from "../../../../shared/components/AppMarkdownParser";

interface Props {
  className?: string;
}

export const FilePreviewer = ({ className }: Props) => {
  const { selectedObject } = useStorageSelectors("userfiles");
  const { fileValue, fileConfig, isFileLoading, handleFilePreviewerActions } =
    useFilePreviewer();

  if (isFileLoading) {
    return <SkeletonPreview />;
  }

  return (
    <div className={styles["files-container"]}>
      {fileConfig?.mimeType !== "application/pdf" && (
        <FilesHeader
          isDisabled={fileValue?.userfiles?.metadata?.admin_only ?? false}
          filePreviewerActions={handleFilePreviewerActions}
          isReadOnly={!selectedObject?.write}
        />
      )}
      {fileConfig?.viewer === "frame" && (
        <FrameComponent
          src={
            fileConfig?.mimeType === "application/pdf"
              ? (fileConfig?.fileContent ?? "")
              : `${DRAWIO_VIEWER_URI}/#R${encodeURIComponent(fileConfig?.fileContent ?? "")}`
          }
          className={classNames(
            fileConfig?.mimeType === "application/xml" &&
              styles["drawio-frame"],
          )}
        />
      )}
      <div className={styles["content"]}>
        {fileConfig?.viewer === "image" && (
          <img
            src={fileConfig?.fileContent as string}
            alt={"Preview"}
            className={styles["preview-image"]}
          />
        )}
        {fileConfig?.viewer === "extracted-text" && (
          <div className={styles["docx-content-wrapper"]}>
            <AppMarkdownParser
              content={fileConfig?.fileContent as string}
              className={styles["markdown-preview"]}
            />
          </div>
        )}
        {fileConfig?.viewer === "audio" && (
          <audio key={fileConfig?.mimeType} controls>
            <source
              src={fileConfig?.fileContent ?? ""}
              type={`audio/${fileConfig.extension}`}
            />
          </audio>
        )}
        {fileConfig?.viewer === "video" && (
          <video
            key={fileConfig?.mimeType}
            controls
            className={styles["preview-video"]}
          >
            <source
              src={fileConfig?.fileContent ?? ""}
              type={`video/${fileConfig?.extension}`}
            />
          </video>
        )}
        {fileConfig?.viewer === "unsupported" && (
          <div className={styles["table-content"]}>
            <div className={styles["message"]}>
              В настоящий момент превью недоступно. Вы можете скачать файл.
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
